module.exports = __webpack_public_path__ + "static/media/virisol_2.47a7134b.png";